import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingPLPSeoTextViewEvent implements GATrackingEvent {

  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PLPSeoText;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PLPSeoText,
      label: this.payload.categoryName
    };
  }
}
